import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  /* border: 1px solid #e9ebee !important; */
`;
